export const TERMS_UPDATED = "10 August 2026";

export const TERMS_SECTIONS = [
  {
    n: 1,
    heading: "Acceptance of these Terms",
    blocks: [
      { type: "p", text: "These Terms of Use apply to your access to and use of the Behaviour Operating System website, including its articles, diagnostics, downloads, forms and other content." },
      { type: "p", text: "The website is operated by Tristan Todd trading as Behaviour Operating System, ABN 79 382 388 533 (“BOS”, “we”, “us” or “our”)." },
      { type: "p", text: "By accessing or using this website, you agree to these Terms of Use." },
      { type: "p", text: "If you do not agree, you must not use the website." },
    ],
  },
  {
    n: 2,
    heading: "About Behaviour Operating System",
    blocks: [
      { type: "p", text: "BOS provides information, diagnostic tools, consulting services and educational material concerning organisational behaviour, operational clarity, execution, leadership practices, accountability and operational performance." },
      { type: "p", text: "The website is intended primarily for business owners, executives, leaders, managers and organisational decision-makers." },
    ],
  },
  {
    n: 3,
    heading: "General information only",
    blocks: [
      { type: "p", text: "Website content is provided for general educational and informational purposes." },
      { type: "p", text: "Unless expressly stated in a written engagement agreement, website content does not constitute:" },
      {
        type: "list",
        items: [
          "legal advice;",
          "financial advice;",
          "psychological or clinical advice;",
          "human-resources advice tailored to a particular organisation;",
          "industrial-relations advice;",
          "workplace investigation findings;",
          "risk, compliance or governance advice;",
          "a formal organisational diagnosis; or",
          "a recommendation to take action concerning a particular employee.",
        ],
      },
      { type: "p", text: "You should obtain appropriate professional advice before acting on information where legal, financial, employment, safety, regulatory or other material consequences may arise." },
    ],
  },
  {
    n: 4,
    heading: "No consultant-client relationship",
    blocks: [
      { type: "p", text: "Accessing the website, subscribing to communications, downloading material, submitting an enquiry or completing a website diagnostic does not create a consultant-client, adviser-client, fiduciary or other professional relationship." },
      { type: "p", text: "A consulting relationship begins only when BOS and the client enter into a separate written agreement or otherwise expressly agree in writing that an engagement has commenced." },
    ],
  },
  {
    n: 5,
    heading: "Diagnostics and assessments",
    blocks: [
      { type: "p", text: "Any diagnostic, questionnaire, score, profile or result provided through the website:" },
      {
        type: "list",
        items: [
          "is a directional business diagnostic;",
          "is completed by a leader and calculated in the browser, without requiring a name, email address or other personal details to access results;",
          "is based on the information submitted;",
          "identifies possible patterns rather than proven causes;",
          "may not account for all relevant organisational factors;",
          "is not psychometric or clinically validated unless expressly stated otherwise;",
          "is not an employee-selection or performance-management instrument;",
          "should not be used as the sole basis for disciplinary, remuneration, restructuring, termination or other employment decisions; and",
          "does not replace a properly scoped organisational review.",
        ],
      },
      { type: "p", text: "You may optionally request an emailed copy after the complete result is displayed. This sends your email address and a derived result summary to our hosting and email-delivery providers for delivery. It does not send the raw answers, individual NA/NV patterns or optional written example, and it does not subscribe you to marketing unless you select the separate newsletter option." },
      { type: "p", text: "Results may be affected by incomplete, inaccurate, subjective or unrepresentative responses." },
      { type: "p", text: "You are responsible for interpreting and using results appropriately." },
    ],
  },
  {
    n: 6,
    heading: "No guaranteed outcomes",
    blocks: [
      { type: "p", text: "Organisational outcomes depend on factors outside BOS’s control, including:" },
      {
        type: "list",
        items: [
          "leadership decisions;",
          "employee participation;",
          "organisational capability;",
          "strategy;",
          "resourcing;",
          "market conditions;",
          "systems;",
          "processes;",
          "implementation quality; and",
          "sustained management action.",
        ],
      },
      { type: "p", text: "We do not guarantee that use of the website, diagnostic or general information will produce a particular operational, financial, cultural, behavioural or performance result." },
      { type: "p", text: "Any examples, case studies, illustrations or hypothetical outcomes are not guarantees of future performance." },
    ],
  },
  {
    n: 7,
    heading: "Accuracy and availability",
    blocks: [
      { type: "p", text: "We take reasonable care when preparing website content. However, information may:" },
      {
        type: "list",
        items: [
          "be generalised;",
          "become outdated;",
          "contain an error;",
          "omit relevant context; or",
          "be unsuitable for a particular organisation.",
        ],
      },
      { type: "p", text: "We may update, remove or change website content without notice." },
      { type: "p", text: "We do not guarantee uninterrupted, secure or error-free access to the website." },
    ],
  },
  {
    n: 8,
    heading: "Your responsibilities",
    blocks: [
      { type: "p", text: "You must:" },
      {
        type: "list",
        items: [
          "use the website lawfully;",
          "provide accurate information when completing forms;",
          "ensure that you have authority to provide information about an organisation;",
          "avoid including unnecessary personal, confidential or sensitive information;",
          "independently assess whether website information is appropriate for your circumstances;",
          "comply with applicable privacy, employment and workplace laws; and",
          "ensure that any use of BOS material within your organisation is fair, appropriate and lawful.",
        ],
      },
    ],
  },
  {
    n: 9,
    heading: "Prohibited conduct",
    blocks: [
      { type: "p", text: "You must not:" },
      {
        type: "list",
        items: [
          "use the website for an unlawful, fraudulent or misleading purpose;",
          "attempt to gain unauthorised access to the website or its systems;",
          "interfere with website operation or security;",
          "introduce malware or harmful code;",
          "scrape, harvest or systematically extract website content or data;",
          "reproduce or commercialise BOS intellectual property without permission;",
          "impersonate another person or organisation;",
          "submit information you are not authorised to disclose;",
          "use a diagnostic to target, shame or unfairly evaluate an identifiable individual; or",
          "use website content in a way that may misrepresent an endorsement, partnership or relationship with BOS.",
        ],
      },
    ],
  },
  {
    n: 10,
    heading: "Intellectual property",
    blocks: [
      { type: "p", text: "Unless otherwise stated, all intellectual property rights in the website and its content are owned by or licensed to BOS." },
      { type: "p", text: "This includes rights in:" },
      {
        type: "list",
        items: [
          "the Behaviour Operating System name;",
          "frameworks;",
          "models;",
          "methods;",
          "diagnostics;",
          "questions;",
          "scoring systems;",
          "reports;",
          "diagrams;",
          "articles;",
          "downloads;",
          "templates;",
          "graphics;",
          "branding;",
          "videos;",
          "workshop content;",
          "terminology; and",
          "website copy.",
        ],
      },
      { type: "p", text: "You may view and print website content for your own internal, non-commercial use." },
      { type: "p", text: "You must not, without prior written permission:" },
      {
        type: "list",
        items: [
          "reproduce substantial parts of the website;",
          "republish website content;",
          "modify or create derivative commercial products;",
          "remove copyright or attribution notices;",
          "sell, license or distribute BOS material;",
          "use BOS material to provide competing services;",
          "incorporate BOS diagnostics or frameworks into another product;",
          "train an artificial intelligence system using BOS material; or",
          "represent BOS intellectual property as your own.",
        ],
      },
    ],
  },
  {
    n: 11,
    heading: "Limited sharing permission",
    blocks: [
      { type: "p", text: "You may share links to publicly available BOS articles or pages, provided that you:" },
      {
        type: "list",
        items: [
          "do not alter the content;",
          "do not imply endorsement;",
          "identify BOS as the source; and",
          "link to the original page where practicable.",
        ],
      },
      { type: "p", text: "Any broader reproduction requires written permission." },
    ],
  },
  {
    n: 12,
    heading: "User submissions",
    blocks: [
      { type: "p", text: "When you submit an enquiry, diagnostic response, feedback or other material, you confirm that:" },
      {
        type: "list",
        items: [
          "the information is accurate to the best of your knowledge;",
          "you are authorised to provide it;",
          "it does not unlawfully infringe another person’s rights; and",
          "its collection and use by BOS for the stated purpose is lawful.",
        ],
      },
      { type: "p", text: "You retain ownership of material you submit." },
      { type: "p", text: "You grant BOS a limited right to use that material to:" },
      {
        type: "list",
        items: [
          "respond to you;",
          "provide requested services;",
          "produce your diagnostic result;",
          "administer an engagement;",
          "improve our services; and",
          "create aggregated or de-identified analysis.",
        ],
      },
      { type: "p", text: "We will not publicly identify you or your organisation in a case study, testimonial or marketing material without permission." },
    ],
  },
  {
    n: 13,
    heading: "Confidential information",
    blocks: [
      { type: "p", text: "The website is not designed as a secure channel for highly confidential, privileged, commercially sensitive or sensitive personal information." },
      { type: "p", text: "Do not submit confidential business data, employee allegations, protected legal material, passwords, financial account details or sensitive personal information through a general website form." },
      { type: "p", text: "Confidentiality obligations applying to consulting engagements will be governed by the relevant engagement agreement." },
    ],
  },
  {
    n: 14,
    heading: "Third-party services and links",
    blocks: [
      { type: "p", text: "The website may use or link to third-party services, including:" },
      {
        type: "list",
        items: [
          "scheduling platforms;",
          "email platforms;",
          "analytics providers;",
          "payment providers;",
          "embedded media;",
          "social networks; and",
          "external publications.",
        ],
      },
      { type: "p", text: "We do not control third-party websites or services and are not responsible for their availability, accuracy, security, privacy practices or content." },
      { type: "p", text: "A link does not necessarily constitute endorsement." },
    ],
  },
  {
    n: 15,
    heading: "Australian Consumer Law",
    blocks: [
      { type: "p", text: "Nothing in these Terms excludes, restricts or modifies a consumer guarantee, right or remedy that cannot lawfully be excluded under the Competition and Consumer Act 2010 (Cth), including the Australian Consumer Law." },
      { type: "p", text: "Where our liability can lawfully be limited, it will be limited to the maximum extent permitted by law." },
    ],
  },
  {
    n: 16,
    heading: "Limitation of liability",
    blocks: [
      { type: "p", text: "To the maximum extent permitted by law, BOS is not liable for indirect, incidental, special or consequential loss arising from use of the website or reliance on its general content, including:" },
      {
        type: "list",
        items: [
          "loss of profit;",
          "loss of revenue;",
          "loss of opportunity;",
          "loss of anticipated savings;",
          "loss of data;",
          "reputational loss; or",
          "business interruption.",
        ],
      },
      { type: "p", text: "This limitation does not apply where liability cannot lawfully be excluded or limited." },
    ],
  },
  {
    n: 17,
    heading: "Indemnity",
    blocks: [
      { type: "p", text: "To the extent permitted by law, you agree to indemnify BOS against loss, liability, cost or expense arising from:" },
      {
        type: "list",
        items: [
          "your unlawful use of the website;",
          "information you submit without authority;",
          "your infringement of intellectual property or privacy rights;",
          "your breach of these Terms; or",
          "your misuse of a diagnostic or website resource.",
        ],
      },
      { type: "p", text: "This clause does not require you to indemnify BOS to the extent the loss was caused by BOS’s negligence, unlawful conduct or breach of contract." },
    ],
  },
  {
    n: 18,
    heading: "Suspension or termination",
    blocks: [
      { type: "p", text: "We may suspend, restrict or terminate access to the website where reasonably necessary to:" },
      {
        type: "list",
        items: [
          "protect website security;",
          "investigate misuse;",
          "comply with law;",
          "protect our intellectual property; or",
          "prevent harm to BOS or another person.",
        ],
      },
    ],
  },
  {
    n: 19,
    heading: "Changes to these Terms",
    blocks: [
      { type: "p", text: "We may update these Terms from time to time." },
      { type: "p", text: "The current Terms will be published on the website with the date of the latest update." },
      { type: "p", text: "Your continued use of the website after updated Terms are published constitutes acceptance of the updated Terms." },
    ],
  },
  {
    n: 20,
    heading: "Governing law",
    blocks: [
      { type: "p", text: "These Terms are governed by the laws of New South Wales, Australia." },
      { type: "p", text: "You submit to the non-exclusive jurisdiction of the courts of New South Wales and courts entitled to hear appeals from them." },
    ],
  },
  {
    n: 21,
    heading: "Severability",
    blocks: [
      { type: "p", text: "If any provision of these Terms is invalid or unenforceable, that provision will be read down or severed to the minimum extent necessary. The remaining provisions will continue to apply." },
    ],
  },
  {
    n: 22,
    heading: "Contact",
    blocks: [
      { type: "p", text: "Questions about these Terms may be directed to:" },
      { type: "p", text: "Behaviour Operating System\nOperated by: Tristan Todd trading as Behaviour Operating System\nABN: 79 382 388 533\nEmail: tristan@behaviouroperatingsystem.com\nSydney, New South Wales, Australia" },
    ],
  },
];
